export default __webpack_public_path__ + "static/media/googlePlay.5a3184fa.png";